<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'OrderSourceCreatePage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ translate('buttons.create') }}
            </router-link>
        </div>
        <Table :columns="columns" :url="url" :handle="tableHandle">
            <template #td-id="{row}">
                <router-link
                    :to="{
                        name: 'OrderSourceEditPage',
                        params: {
                            orderSourceUuid: row.uuid
                        }
                    }"
                >
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-imageFile="{row}">
                <ImageZoomComponent
                    :url="row?.image_file?.url || PLACEHOLDER_IMAGE_URL"
                    :alt="row.name"
                    :default-width="50"
                    :default-height="50"
                />
            </template>
            <template #td-integration="{row}">
                <AppNullableCell>
                    <template #default v-if="row.integration">
                        {{ row.integration.name }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-created_at="{row}">
                <span>{{ DateFormatter.formatDateTime(row.created_at) }}</span>
            </template>
            <template #td-color="{row}">
                <span :class="`badge`" :style="{
                    'color': 'white',
                    'background-color': row.color
                }">{{ $t('labels.color') }}</span>
            </template>
            <template #td-price_template="{row}">
                <AppNullableCell>
                    <template #default v-if="row.price_template">
                        {{ row.price_template.name }}
                    </template>
                </AppNullableCell>
            </template>
        </Table>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import Table from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../components/tables/AppNullableCell.vue";
import ImageZoomComponent from "../../../../components/new/image/ImageZoomComponent.vue";

import DateFormatter from "../../../../services/DateFormatter";
import { PLACEHOLDER_IMAGE_URL } from "../../../constants";

export default {
    name: 'OrderSourceIndexPage',
    components: {
        Card, Table, AppNullableCell, ImageZoomComponent
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            PLACEHOLDER_IMAGE_URL,
            DateFormatter,
            url: `/projects/${this.$route.params.projectUuid}/crm/sources`,
            columns: [
                {key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: true},
                {key: 'imageFile', name: this.$t('table.titles.image'), width: '80px', type: 'string', order: false},
                {key: 'name', name: this.$t('table.titles.name'), width: 'auto', type: 'string', order: false},
                {key: 'price_template', name: this.$t('table.titles.price_template'), width: '150px', type: 'string', order: false},
                {key: 'color', name: this.$t('labels.color'), width: '100px', type: 'string', order: false},
                {key: 'integration', name: this.$t('table.titles.integration'), width: '150px', type: 'string', order: false},
                {key: 'created_at', name: this.$t('table.titles.created_at'), width: '150px', type: 'string', order: true},
            ]
        }
    },
    mounted() {
        this.tableHandle.fetchRows({
            extra_fields: ['integration', 'imageFile', 'priceTemplate']
        });
    }
}
</script>
<style scoped>
</style>
